import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import { slug } from 'utils';
import _ from 'lodash';
import RaceJSONLD from 'modules/Common/components/RaceJSONLD';


import {localTimeShort} from 'utils/LocalDateTimeHelper'; // function
import {LocalTimeShort} from 'modules/Common/components/LocalDateTime'; // component

import CollapsibleSection from 'modules/Common/components/CollapsibleSection';
import CaretIcon from 'modules/Common/components/svg/CaretIcon';

import { GREYHOUND_RACE_COMPLETE_STATUSES } from 'modules/Common/consts';

export default function RacecardsMeetingSummary(props) {
  const meeting = props.meeting;

  // TODO: get this information from the request
  const isBags = false;

  meeting.races = _.sortBy(meeting.races, ['date', function(race) { return localTimeShort(`${race.date}T${race.time}Z`)}]);

  const meetingDate = props.date;
  const courseNameSlug = slug(meeting.meeting_summary.course.name).toLowerCase();

  return (
    <section className="gh-meeting-container">
      <RaceJSONLD {...{meeting}} sport='greyhounds' type='racecard'/>
      { props.dateIncrement === 1 ?
        <CollapsibleSection title={meeting.meeting_summary.course.name}> {/* Racecards for date page */}
          { isBags && <div className="gh-meeting-meta">
            {/* Need to determine when to show this */}
            <div className="gh-meeting-meta-bags"><span className="gh-meeting-meta-label">BAGS</span></div>
          </div>}

          <ul className="gh-meeting-races-container">


            {meeting.races.map((race) => {
              return <li key={race.race_summary_reference.id}>
                <Link className={GREYHOUND_RACE_COMPLETE_STATUSES.includes(race.race_stage) ? "gh-meeting-race-resulted" : ""} to={`/greyhounds/racecards/${meetingDate}/${courseNameSlug}/racecard/${race.race_summary_reference.id}`}>
                  <LocalTimeShort className="gh-meeting-race-time" iso={`${race.date}T${race.time}Z`} />
                </Link>
              </li>;
            })}
          </ul>
        </CollapsibleSection>
        :
        <div className="dividerRow"> {/* Results for date page */}
          <div className="divider-title">
            <div className="divider-title-text">
              <span>{meeting.meeting_summary.course.name}</span>
            </div>
            <div className="divider-subtitle"><Link to={"/greyhounds/fast-results"}><CaretIcon type="full" direction="right"/>&nbsp;Fast Results</Link></div>
          </div>
          <ul className="gh-meeting-races-container">
            {meeting.races.map((race) => {
              return <li key={race.race_summary_reference.id}>
                <Link className={GREYHOUND_RACE_COMPLETE_STATUSES.includes(race.race_stage) ? "gh-meeting-race-resulted" : ""} to={`/greyhounds/racecards/${meetingDate}/${courseNameSlug}/racecard/${race.race_summary_reference.id}`}>
                  <LocalTimeShort className="gh-meeting-race-time" iso={`${race.date}T${race.time}Z`} />
                </Link>
              </li>;
            })}
          </ul>
        </div>
      }
    </section>
  );
}

RacecardsMeetingSummary.propTypes = {
  meeting: PropTypes.object.isRequired,
  date: PropTypes.string.isRequired,
  dateIncrement: PropTypes.number
};



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/components/GreyhoundRacingRacecardsMeetingSummary.js